// Sticky ATC Bar
window.addEventListener('scroll', () => {
  const productInfo = document.querySelector('.product-information');
  const stickyBar = document.querySelector('#StickyATCBar');

  if (!productInfo || !stickyBar) return;

  // Get header height from CSS variable
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height')
  ) || 500;

  const productInfoBottom = productInfo.getBoundingClientRect().bottom - headerHeight;
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  const scrollPosition = window.scrollY + windowHeight;

  if (productInfoBottom <= 0) {
    stickyBar.classList.add('active');
  } else {
    stickyBar.classList.remove('active');
  }

  if (scrollPosition >= documentHeight) {
    stickyBar.classList.remove('active');
  }
});

// Function to handle variantId update
let updateTimeout = null;

function updateStickyATCBar() {
  if (updateTimeout) clearTimeout(updateTimeout);

  updateTimeout = setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId) {
      // Update variantId input
      const variantInput = document.querySelector('#StickyATCBar product-form-component form.shopify-product-form input[ref="variantId"]');
      if (variantInput) {
        variantInput.value = variantId;
      }

      // Update Image
      const productImage = document.querySelector('.product-media-constraint-wrapper img');
      const stickyImage = document.querySelector('#StickyATCBar .image-block img');
      console.log('productImage', productImage.src, 'stickyImage', stickyImage.src);

      if (productImage && stickyImage) {
        console.log('productImage && stickyImage');
        stickyImage.src = productImage.src;
        stickyImage.srcset = productImage.srcset;
      }

      // Update Price HTML
      const sourcePriceContainer = document.querySelector('.product-details product-price [ref="priceContainer"]');
      const targetPriceContainer = document.querySelector('#StickyATCBar product-price [ref="priceContainer"]');
      if (sourcePriceContainer && targetPriceContainer) {
        targetPriceContainer.innerHTML = sourcePriceContainer.innerHTML;
      }
    }
  }, 2000); // 2 seconds delay
}

// Initial update on page load
updateStickyATCBar();

// Observe URL changes (for SPAs or history API updates)
const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;

history.pushState = function (...args) {
  originalPushState.apply(this, args);
  updateStickyATCBar();
};

history.replaceState = function (...args) {
  originalReplaceState.apply(this, args);
  updateStickyATCBar();
};

window.addEventListener('popstate', updateStickyATCBar);